@if (manager && managee && showNav) {
  <section id="conversation-sidenav">
    @if (isMobile) {
      <ninety-button flat primary icon (click)="toggleNav(false)" style="align-self: end">
        <terra-icon icon="x" size="20" />
      </ninety-button>
    }
    @if (feedbackService.conversationSectionUpdate$ | async; as currentSection) {
      @if (!viewingTool) {
        <div class="conversation-sections">
          @if (isConversationManager || canEvaluateSelf) {
            <h3>
              {{ managee?.metadata?.name | displayFullName }}
              @if (!isMeeting) {
                <small>(review {{ isConversationManager ? 'your ' + language?.feedback?.managee : 'yourself' }})</small>
              }
            </h3>
          }
          @if (isConversationManager || canEvaluateSelf) {
            <ol>
              @for (section of manageeSections; track section.elementId) {
                <li
                  attr.data-cy="conversation-sidenav_managee-section-name-{{ section.title }}"
                  attr.data-cy="conversation-sidenav_sidenav-link-{{ section.title }}"
                  class="sidenav-link"
                  [ngClass]="{ active: currentSection?.elementId === section.elementId }"
                  (click)="setSection(section)">
                  {{ section.title }}
                </li>
              }
            </ol>
          }
          @if (canEvaluateManager) {
            <h3>
              {{ manager?.metadata?.name?.first + ' ' + manager?.metadata?.name?.last }}
              @if (!isMeeting) {
                <small>(review {{ isConversationManager ? 'yourself' : 'your ' + language?.feedback?.manager }})</small>
              }
            </h3>
          }
          @if (canEvaluateManager || isMeeting) {
            <ol>
              @if (canEvaluateManager) {
                @for (section of managerSections; track section.elementId) {
                  <li
                    attr.data-cy="conversation-sidenav_manager-section-name-{{ section.title }}"
                    class="sidenav-link"
                    [ngClass]="{ active: currentSection?.elementId === section.elementId }"
                    (click)="setSection(section)">
                    {{ section.title }}
                  </li>
                }
              }
              @if (isMeeting) {
                @for (section of signatureSections; track section.elementId) {
                  <li
                    class="sidenav-link"
                    (click)="setSection(section)"
                    [ngClass]="{ active: currentSection?.elementId === section.elementId }">
                    {{ section.title }}
                  </li>
                }
              }
            </ol>
          }
        </div>
      }
    }
    <div class="fill-remaining-space"></div>
    @if (showSaveButtons$ | async) {
      <div class="flex-column">
        @switch (feedbackService.autoSaveStatus()) {
          @case ('saving') {
            <span class="auto-save-status" data-cy="conversation-sidenav_auto-save-status">Saving...</span>
          }
          @case ('saved') {
            <span class="auto-save-status" data-cy="conversation-sidenav_auto-save-status">
              <terra-icon icon="check" size="16" /> Last saved {{ feedbackService.lastAutoSavedAt() | date: 'h:mm a' }}
            </span>
          }
          @case ('error') {
            <span class="auto-save-status error" data-cy="conversation-sidenav_auto-save-status">
              <terra-icon icon="warning-circle" size="16" /> Couldn't save changes
            </span>
          }
        }
        <ninety-button
          icon
          stroked
          class="button-tertiary full-width"
          data-cy="conversation-sidenav_save-for-later-button"
          (click)="saveConversation(false)"
          [disabled]="feedbackService.disableSidenavButtons()">
          <terra-icon icon="save" size="20" />
          <span>Save for Later</span>
        </ninety-button>
        <ninety-button
          filled
          primary
          icon
          data-cy="converssation-sidenav_finish-button"
          class="button-primary full-width"
          (click)="isMeeting ? finishMeeting() : saveConversation(true)"
          [disabled]="feedbackService.disableSidenavButtons()">
          <terra-icon icon="check" size="20" />
          <span>Finish</span>
        </ninety-button>
      </div>
    }
    @if (isMeeting) {
      <div class="flex-column view-tool-container">
        <ninety-button
          icon
          flat
          [matMenuTriggerFor]="viewAnotherToolMenu"
          data-cy="conversation-sidenav_view-tool-button"
          class="menu-btn uppercase full-width view-tool-button"
          aria-label="View Another Tool"
          [disabled]="!isMeeting">
          View Tool
          <terra-icon icon="tool" />
        </ninety-button>
        <mat-menu #viewAnotherToolMenu="matMenu" xPosition="before" yPosition="above">
          <a
            mat-menu-item
            [routerLink]="[
              '',
              {
                outlets: {
                  detail: null,
                  primary: [
                    '1-on-1',
                    'discussion',
                    conversationId,
                    conversationBOS === 'EOS' ? conversationToolType.meeting : conversationToolType.conversationMeeting,
                  ],
                },
              },
            ]"
            routerLinkActive="active">
            <terra-icon icon="one-on-one" />
            {{ language?.feedback?.route }} {{ language?.feedback?.meeting }}
          </a>
          <a
            mat-menu-item
            [routerLink]="[
              '',
              {
                outlets: { detail: null, primary: ['1-on-1', 'discussion', conversationId, conversationToolType.data] },
              },
            ]"
            routerLinkActive="active">
            <terra-icon icon="data" />
            {{ language?.scorecard?.route }}
          </a>
          <a
            mat-menu-item
            [routerLink]="[
              '',
              {
                outlets: {
                  detail: null,
                  primary: ['1-on-1', 'discussion', conversationId, conversationToolType.rocks],
                },
              },
            ]"
            routerLinkActive="active">
            <terra-icon icon="mountains" />
            {{ language?.rock?.route }}
          </a>
          <a
            mat-menu-item
            [routerLink]="[
              '',
              {
                outlets: {
                  detail: null,
                  primary: ['1-on-1', 'discussion', conversationId, conversationToolType.todos],
                },
              },
            ]"
            routerLinkActive="active">
            <terra-icon icon="to-dos" />
            {{ language?.todo?.route }}
          </a>
          <a
            mat-menu-item
            [routerLink]="[
              '',
              {
                outlets: {
                  detail: null,
                  primary: ['1-on-1', 'discussion', conversationId, conversationToolType.issues],
                },
              },
            ]"
            routerLinkActive="active">
            <terra-icon icon="issues" />
            {{ language?.issue?.route }}
          </a>
          <a
            mat-menu-item
            [routerLink]="[
              '',
              {
                outlets: { detail: null, primary: ['1-on-1', 'discussion', conversationId, conversationToolType.vto] },
              },
            ]"
            routerLinkActive="active">
            <terra-icon icon="vision" />
            {{ language?.vto?.route }}
          </a>
          <a
            mat-menu-item
            [routerLink]="[
              '',
              { outlets: { detail: null, primary: ['1-on-1', 'discussion', conversationId, conversationToolType.ac] } },
            ]"
            routerLinkActive="active">
            <terra-icon icon="responsibilities" />
            {{ language?.acChart?.route }}
          </a>
          <a
            mat-menu-item
            [routerLink]="[
              '',
              {
                outlets: {
                  detail: null,
                  primary: ['1-on-1', 'discussion', conversationId, conversationToolType.directory],
                },
              },
            ]"
            routerLinkActive="active">
            <terra-icon icon="directory" />
            {{ language?.directory?.route }}
          </a>
        </mat-menu>
      </div>
    }
  </section>
}
